import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={(styles["codicon"] || "codicon") + " " + (styles["codicon-video-icons-next"] || "codicon-video-icons-next")} viewBox="0 0 21 27" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="evenodd"><path d="M.227 2.658L17.45 13.721.227 24.784z" /><path d="M16.367.721h4v26h-4z" /></g></svg>;